import { render } from "./AboutUsRes.vue?vue&type=template&id=1124620e&scoped=true"
import script from "./AboutUsRes.vue?vue&type=script&lang=js"
export * from "./AboutUsRes.vue?vue&type=script&lang=js"

import "./AboutUsRes.vue?vue&type=style&index=0&id=1124620e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src618844026/src/meta-page-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1124620e"]])

export default __exports__